module.exports = __webpack_public_path__ + "img/save-to-drive.344dae97.svg";